<template>
<div>
  <div class="modal fade" data-backdrop="static" id="modal-confirm-moving">
    <div class="modal-dialog" style="width:700px !important;">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title" style="text-align:center;">{{$t('apartmentbookings.title_moving')}}</h2>
          </div>
          <div class="modal-body">
            <b-form>
              <div class="row">
                <div v-show="dataNotMove.length > 0" class="col-sm-12 col-md-12 col-lg-12">
                  <span style="color: red;font-weight:bold;">{{$t('apartmentbookings.title_apartment_not_move')}}</span>
                  <b-table :items="dataNotMove" :fields="apartmentNotMove" class="mt-3" outlined>
                    <template #head()="scope">
                      <div>{{ $t(scope.label) }}</div>
                    </template>
                  </b-table>
                </div>
                <div v-show="dataMove.length > 0" class="col-sm-12 col-md-12 col-lg-12">
                  <span style="color: green;font-weight:bold;">{{$t('apartmentbookings.title_apartment_move')}}</span>
                  <b-table :items="dataMove" :fields="apartmentMove" class="mt-3" outlined>
                  <template #head()="scope">
                    <div>{{ $t(scope.label) }}</div>
                  </template>
                  </b-table>
                </div>
              </div>
            </b-form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary btn-sm pull-right mg-left"
              @click="movingConfirmation"
            >{{$t('common.confirm')}}</button>
            <button
              type="button"
              class='btn btn-warning btn-sm pull-left'
              @click="closeModal"
            >{{$t('common.back')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
    </div>
  </div>
  <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
//import moment from 'moment'
import LTECoreAlert from "@/components/LTESnackBar.vue";

export default {
  name: 'LTEModalConfirmMovingApartment',
  data() {
    return {
        options: {
            format: "DD/MM/YYYY",
            useCurrent: false
        },
        dataMovingList: [],
        dataMove:[],
        dataNotMove:[],
        idsList:[],
        apartmentMove: [
          { key: 'code', label: "common.code", sortable: true, class: 'text-center' },
          { key: 'apartment_code', label: 'apartment.apartment_code', sortable: true, class: 'text-center' },
          { key: 'size', label: 'apartment.size', sortable: true, class: 'text-center' }
          //{ key: 'owner_resident', label: 'apartment.owner_resident', sortable: true, class: 'text-center'}
        ],
        apartmentNotMove: [
        { key: 'apartment_code', label: "apartment.apartment_code", sortable: true, class: 'text-center' },
        { key: 'arrived_start_date', label: 'apartmentbookings.arrived_start_date', sortable: true, class: 'text-center' },
        { key: 'booking_code', label: 'apartmentbookings.booking_code', sortable: true, class: 'text-center' },
        { key: 'checkin_datetime', label: 'apartmentbookings.checkin_datetime', sortable: true, class: 'text-center'},
        { key: 'checkout_datetime', label: 'apartmentbookings.checkin_datetime', sortable: true, class: 'text-center'}
      ],
    };
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR"
    ])
  },
  methods: {
    submit(data_list) {
        this.idsList = [];
        this.dataMovingList = data_list
        this.dataMove = data_list.apartments_move
        this.dataNotMove = data_list.apartments_not_move
        this.dataMove.forEach(item => {
          this.idsList.push(item.id)
        });
        $("#modal-confirm-moving").modal("show");
    },
    closeModal: function() {
        $("#modal-confirm-moving").modal("hide");
        this.disabledCheckin = true
    },
    movingConfirmation: function() {
      $("#modal-confirm-moving").modal("hide");
      this.$emit("movingconfirmation", this.idsList);
    },
    ...mapActions([
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "ERROR_TOAST"
    ])
  },
  mounted() {
  },
  components: {
    "lte-core-alert": LTECoreAlert
  },
}
</script>
<style lang="scss" scoped>
    .mg-left {
        margin-left: 5px;
    }
    .hide-scroll-bar::-webkit-scrollbar {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/LTEModalConfirmMovingApartment.vue